// article-tabs.js

document.addEventListener("DOMContentLoaded", () => {
  // Active ToC link based on scroll position
  document.querySelectorAll(".article-tab-wrapper .table-of-contents").forEach((toc) => {
    const links = Array.from(toc.querySelectorAll('a[href^="#"]'));
    if (!links.length) return;

    const targets = links
      .map((a) => document.querySelector(a.getAttribute("href")))
      .filter(Boolean);

    if (!targets.length) return;

    const setActive = (id) => {
      links.forEach((a) => {
        a.classList.toggle("active", a.getAttribute("href") === `#${id}`);
      });
    };

    const io = new IntersectionObserver(
      (entries) => {
        entries.forEach((e) => {
          if (e.isIntersecting && e.target.id) setActive(e.target.id);
        });
      },
      {
        rootMargin: "-20% 0px -70% 0px",
        threshold: 0.01,
      }
    );

    targets.forEach((t) => io.observe(t));
    setActive(targets[0].id);
  });
});